import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorStatusService {
  public globalFatalError = signal(false);

  setGlobalFatalError(hasError: boolean): void {
    this.globalFatalError.set(hasError);
  }
}
